export { SchoolEntity } from './school-entity';
export { SchoolEntityList } from './school-entity-list';
export { SchoolSummaryStatsEntity } from './school-summary-stats-entity';

export type { Entity as SchoolEntityType } from './school-entity';
